export const saveAffiliateData = (event: string) => {

    if (!event) {
        return 
    }

    let affiliateSaved = localStorage.getItem('affiliate_' + event)

    if (affiliateSaved) {
        return
    }

    console.log('saveAffiliateData', event)
    
	let resolved = false

    try {


        var botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
        var re = new RegExp(botPattern, 'i');
        var userAgent = navigator.userAgent; 
        if (re.test(userAgent)) {
            resolved = true

            return
        }

        if (!affiliateSaved) {
            localStorage.setItem('affiliate_' + event, 'saved')

            const id = localStorage.getItem("affiliate_db_id");
            const affiliate_id = localStorage.getItem("affiliate_id") || "TradingApp";
            const at_gd = localStorage.getItem("at_gd");
            const ref = localStorage.getItem("ref");
            const affiliate_campaign = localStorage.getItem("affiliate_campaign") || "";
            const affiliate_referrer = localStorage.getItem("affiliate_referrer") || "";
            const affiliate_utm_source = localStorage.getItem("affiliate_utm_source") || localStorage.getItem("utm_source") || "";
			const affiliate_utm_medium = localStorage.getItem("affiliate_utm_medium") || localStorage.getItem("utm_medium") || "";
			const affiliate_utm_campaign = localStorage.getItem("affiliate_utm_campaign") || localStorage.getItem("utm_campaign") || "";
            const affiliate_path = localStorage.getItem("affiliate_path") || "";

            const affiliate_language = localStorage.getItem("affiliate_language");
            let affiliate_browser_language = localStorage.getItem("affiliate_browser_language");
    
            if (!affiliate_browser_language) {
                const browser_language = navigator.language || (navigator as any).userLanguage; //no ?s necessary
                if (browser_language) {
                    affiliate_browser_language = browser_language
                }
            }

            if (affiliate_id || at_gd) {
                fetch("https://api.morpher.com/v1/web/sendAnalytics", {
                    method: "POST",
                    body: JSON.stringify({
                        event: "affiliate_data",
                        data: {
                            affiliate_id,
                            affiliate_campaign,
                            affiliate_referrer,
                            affiliate_utm_source,
                            affiliate_utm_medium,
                            affiliate_utm_campaign,
                            affiliate_path,
                            at_gd,
                            ref,
                            source_id: localStorage.getItem("source_id") || undefined,
                            affiliate_language,
                            affiliate_browser_language,
                            id,
                            event
                        },
                    }),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                }).then((result) => {
                    try {
                        result.json().then((json) => {
                            if (json?.id) {
                                localStorage.setItem('affiliate_db_id', json.id.toString())
                            }
                        } )
                    } catch (err) {
                        console.log("Error in saveAffiliateData", err);
                    }
                    
                    localStorage.setItem("affiliate_saved", "1")
                    resolved = true
                }).catch((err) => {
                    console.log("Error in saveAffiliateData", err);
                    resolved = true
                })
            } 
        } else {
            resolved = true
        }
    } catch (err) {
        resolved = true
        console.log("Error in saveAffiliateData", err);
    }
	
};